import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Card, Typography } from '@mui/material'
import { format } from '@e3dc-react/shell/Libs/date'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { ORDER_HISTORY_DATE_FORMAT } from '../../consts'

interface MoreDetailsCardProps {
  billingAddress: string
  shippingAddress: string
  desiredDeliveryDate: string
  customerName: string
}

const useStyles = makeStyles()(theme => ({
  orderDetailsWrapper: {
    paddingBottom: theme.spacing(2),
    marginTop: theme.spacing(4),
    backgroundColor: theme.palette.background.paper2,
  },
  orderDetailsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    flexWrap: 'nowrap',
    [theme.breakpoints.down('md')]: {
      flexWrap: 'wrap',
    },
  },
  infoContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    whiteSpace: 'nowrap',
    maxWidth: '150px',
    minWidth: '150px',
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(2),
    },
  },
  detailsText: {
    marginTop: theme.spacing(1),
    whiteSpace: 'pre-line',
  },
}))

/*
 * This component shows more data for a order history details like, billing, name of the user who ordered and delivery date
 */
const MoreDetailsCard: React.FC<MoreDetailsCardProps> = ({ billingAddress, shippingAddress, desiredDeliveryDate, customerName }) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()

  return (
    <Card className={classes.orderDetailsWrapper}>
      <Box className={classes.orderDetailsContainer}>
        <Box className={classes.infoContainer}>
          <Typography variant="body2">{t('shop.order-history-card.billing-address')}</Typography>
          <Typography variant="h3" className={classes.detailsText}>
            {billingAddress.replace(/\r/g, ' ')}
          </Typography>
        </Box>
        <Box className={classes.infoContainer}>
          <Typography variant="body2">{t('shop.order-history-card.shipping-address')}</Typography>
          <Typography variant="h3" className={classes.detailsText}>
            {shippingAddress.replace(/\r/g, ' ')}
          </Typography>
        </Box>
        <Box className={classes.infoContainer}>
          <Typography variant="body2">{t('shop.order-history-card.desired-shipping-date')}</Typography>
          <Typography variant="h3" className={classes.detailsText}>
            {desiredDeliveryDate ? format(new Date(desiredDeliveryDate), ORDER_HISTORY_DATE_FORMAT) : t('shop.order-history-card.no-date')}
          </Typography>
        </Box>
        <Box className={classes.infoContainer}>
          <Typography variant="body2">{t('shop.order-history-card.customer')}</Typography>
          <Typography variant="h3" className={classes.detailsText}>
            {customerName}
          </Typography>
        </Box>
      </Box>
    </Card>
  )
}

export default MoreDetailsCard
